import Nullstack from 'nullstack';
export default function IconBuildingStadium({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-building-stadium",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("ellipse", {
    cx: "12",
    cy: "12",
    rx: "8",
    ry: "2"
  }), "   ", Nullstack.element("path", {
    d: "M4 12v7c0 .94 2.51 1.785 6 2v-3h4v3c3.435 -.225 6 -1.07 6 -2v-7"
  }), "   ", Nullstack.element("path", {
    d: "M15 6h4v-3h-4v7"
  }), "   ", Nullstack.element("path", {
    d: "M7 6h4v-3h-4v7"
  }), " ");
}